import React, { useEffect, useState } from 'react';
// import { Container, Typography, FormControl, InputLabel, Input, Box, FormGroup, Button } from '@material-ui/core';
import { Navigate, useNavigate, useParams } from "react-router-dom";
import {serviceGetPatientDetail, serviceUpdatePatientDetail,getProgramData} from  "../Services/Service";
import { ModalBox } from "../Services/CommonLibrary"
import './Home.css';

const initialValue = {
    
    mobile: "",
    btnValue: "",
    action:"",
    updateId:"",
    programSelect:"",
    email:"",
    checkProgramId: []
}

const UserAdd = () => {
    const [checked, setChecked] = useState([]);
    const [user, setUser] = useState(initialValue);
    // const {mobile,btnValue,action,updateId} = user;

    const [isvalid, setIsvalid] = useState(true);
    const [formErrors, setFormErrors] = useState('');
    const [headTitle, setHeadTitle] = useState([]);
    const navigate = useNavigate();
    const { id } = useParams();
    const [programData, setProgramData] = useState([]);

    const [showModal, setShowModal] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalBody, setModalBody] = useState('');
    const handleClose = () =>{  setShowModal(false);}
    
    
    useEffect(() => {
        if(id != '' && id !== undefined){
            setHeadTitle('Update Patient');
            console.log(user);
        }
        
    },[id,user]);
    useEffect(() => {
            loadUserData();
            fetchProgramList(); 
    },[]);

    const fetchProgramList = async () => {
        await getProgramData()
            .then((res) => {
                setProgramData(res?.data?.data)
            }
        );
    }
    const loadUserData = async () =>{
        
        const response = await serviceGetPatientDetail({updateId:id});
        setUser({...user, ['btnValue']: 'Update',['updateId']: id,['email']: response.data.data[0].email,['mobile']: response.data.data[0].mobile,['programSelect']: response.data.data[0].programId,['checkProgramId']: response.data.data[0].checkProgramID});
        setChecked(response.data.data[0].checkProgramID);
    }

    const checkMobile = async () =>{
        let modalBodyComponent='';
        const response = await serviceUpdatePatientDetail(user);
        setModalTitle('Alert!')
        if(response.data.status==2){
            modalBodyComponent=<><span>{response.data.message} <br/><br/> Note : <p><em>{response.data.note}</em></p> <br/><br/> <button className='btn btn-primary' onClick={updateMobile}>Continue</button> <button className='btn btn-secondary' onClick={handleClose}>Cancel</button></span></>;
        }else{
            modalBodyComponent=<><span>{response.data.message}</span></>;
        }
        setModalBody(modalBodyComponent);
        setShowModal(true);
    }
    const updateMobile = async () =>{
        let modalBodyComponent='';
        setShowModal(false);
        const newval = {...user, confirm: 'yes'}
        setUser(newval);
        const response = await serviceUpdatePatientDetail(newval);
        if(response.data.status==1){
             modalBodyComponent=<><span>{response.data.message}</span></>;
        }else{
            modalBodyComponent=<><span>{response.data.message}</span></>;
        }
        
        setUser({...user, confirm: ''});
        setModalTitle('Alert!');
        
        setModalBody(modalBodyComponent);
        setShowModal(true);
    }

    const onValueChange = (e) =>{
        console.log(e.target.name,e.target.value);
        if(e.target.name == "mobile"){
            e.target.value =  e.target.value.replace(/\D/g, "");
        }
        setUser({...user, [e.target.name]: e.target.value});
    }

    
    function validateForm(){
        let validform = true;
        let error = '';
        if(user.mobile.length!=10){
            validform = false;
            error = 'Please Enter 10 digit mobile number.'
        } 
        if(user.checkProgramId.length==0){
            validform = false;
            error = 'Please Select Program.';
        } 
        
        if(!validform){  
            setModalTitle('Alert');
            setModalBody(<span>{error}</span>);
            setShowModal(true);
        }   
        return validform;   
    }
    const submitHandle = e => {
         e.preventDefault();
        let isvalidForm = validateForm();
        if(isvalidForm && isvalid){
            checkMobile();
            console.log('submitted');
        }else{
            console.log('isvalid false');
            console.log(formErrors);
        }      
    }
    const handleSelectAll=(event)=>{
        const checks=document.querySelectorAll(".form-check-input")
        var updatedList = [...checked];
        if (event.target.checked){
            programData.map((item, index) => {
                if(!updatedList.includes(item.programId)){
                    updatedList = [...updatedList, item.programId]
                }
                // console.log(item.programId)
            })
            checks.forEach(check=>check.checked=true)
        }else{
            updatedList=[]
            checks.forEach(check=>check.checked=false)
        }
        // console.log(updatedList)
        setChecked(updatedList);
        setUser({...user, ['checkProgramId']: updatedList});
    }
    const handleCheck = (event) => {
        var updatedList = [...checked];
        if (event.target.checked) {
          updatedList = [...checked, event.target.value];
        } else {
            document.querySelector("#select_all_check").checked=false
          updatedList.splice(checked.indexOf(event.target.value), 1);
        }
        // console.log(updatedList)
        setChecked(updatedList);
        setUser({...user, ['checkProgramId']: updatedList});
    };
    return (
        <>
            <section className='projects-section'>
            <div className='row'>
                <h1 className='title mb-4'>{headTitle}</h1>
                {formErrors!='' ? <div className={"alert alert-danger col-md-4"} role="alert">{formErrors}</div> : null}
                <form onSubmit={submitHandle} className=''>
                
                <div className="clearfix"></div>
                <div className="col-md-6">
                    <div className="form-floating mb-3">
                        <input type="email" id="form2Example4" className="form-control" required name="email" value={user.email} onChange={(e) => onValueChange(e)} />
                        <label className="form-label">Email</label>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-floating mb-3">
                        <input type="text" id="form2Example3" className="form-control" required name="mobile" maxLength="10" value={user.mobile} onChange={(e) => onValueChange(e)} />
                        <label className="form-label">Mobile</label>
                    </div>
                </div>
                <div className="col-md-6">
                    <div style={{display:"flex",justifyContent:"space-between"}} className="clearfix">
                        <div style={{width:"50%"}}>Program List</div>
                        <div style={{width:"50%",display:"flex",justifyContent:"flex-end"}}>
                        <input onClick={(e)=>{handleSelectAll(e)}} type="checkbox" id="select_all_check" />
                        <label htmlFor="select_all_check" className="form-check-label" style={{marginLeft: "5px"}}>Select All</label>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-floating mb-3 form-check">
                    {programData?.map((item, index) => (
                        <div key={index} className="multiCheckbox">
                            <input
                            className="form-check-input"
                            style={{ fontStyle: "normal" }}
                            type="checkbox"
                            id={item.programId}
                            value={item.programId}
                            // checked={item.isAdded}
                            
                            checked={user.checkProgramId.length>0 ? (user.checkProgramId.find((programId) => (programId.includes(item.programId) ) ? true:false) ) : null}
                            onChange={handleCheck}
                            />
                        <label className="form-check-label" htmlFor={item.programId}>
                        {item.programName}
                        </label>
                        </div>
                        ))}
                        
                    </div>
                </div>
                {/* <div className="col-md-6">
                    <div className="form-floating mb-3">
                    <select id="programSelect" name="programSelect" className='form-control' value={user.programSelect} onChange={onValueChange} >
                            <option value="">-- SELECT PROGRAM --</option>
                            {programData.map((data, i) => (
                                <option value={data.programId}  key={i}>{data.programName}</option>
                            ))}
                        </select>
                    </div>
                </div> */}
                
                <div className="clearfix"></div>
                <div className="col-md-6 mt-3">
                    <button type="submit" className="btn btn-primary btn-login mb-4" name="btnValue">{user.btnValue}</button>
                </div>
                    
                </form>
                </div>
                {showModal?<ModalBox handleClose={handleClose} showModaln={showModal} titlen={modalTitle} bodyn={modalBody}/>:null}
</section>

        </>
    )
}


export default UserAdd;